import { Sparkles } from "lucide-react";

export const ComingSoonBadge = ({ className = "", label = "Coming soon", testId = "coming-soon-badge" }) => {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full bg-[#FFF1E8] text-[#B54708] border border-[#FFD7BF] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${className}`}
    >
      <Sparkles className="h-3 w-3" aria-hidden="true" />
      {label}
    </span>
  );
};
